import { render, staticRenderFns } from "./RipaFormStep7.vue?vue&type=template&id=62c632d5"
import script from "./RipaFormStep7.vue?vue&type=script&lang=js"
export * from "./RipaFormStep7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports